import { useRouter } from 'next/navigation';

export const useNavigation = () => {
  const router = useRouter();

  const handleNavigation = (url: string | undefined | null) => {
    if (!url) return;

    if (url.startsWith("tel:") || url.startsWith("mailto:")) {
      window.location.href = url;
      return;
    }

    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    router.push(url);
  };

  return { handleNavigation };
};
